import { useEffect, useState } from 'react'

import Experience from '../../experience'

import { UseSceneProps } from '../types'

const useScene = ({ targetRef, experience }: UseSceneProps) => {
  const [step, set] = useState(0)

  /**
   * Init experience
   */
  useEffect(() => {
    if (targetRef?.current) {
      experience.current = new Experience({
        targetElement: targetRef.current,
      })
    }

    const clear = () => {
      experience.current?.stop()
      set(0)
    }

    return () => clear()
  }, [experience, targetRef])

  /**
   * Manage navigation updates
   */
  useEffect(() => experience.current?.navigation(step), [experience, step])

  return { step, set, experience, targetRef }
}

export default useScene
